<template>
  <div
    :class="classList"
    class="multi-select-container"
    v-if="displayedOptionList && displayedOptionList.length"
  >
    <label class="form-label-btn" v-if="label"
      >{{ label.trim().replace(/\*$/, "") }}
      <span v-if="isRequired" class="asterisk-mark">*</span>
      <div class="setting-container" v-if="hasAddOptionBtn">
        <i
          class="material-icons ml-2 add-option-icon"
          @click="$emit('clickBtn', 'add-option')"
          v-tooltip="'Add Option'"
        >
          add_circle_outline
        </i>
      </div>
    </label>
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <MultiSelect
      id="multiselect-select-field"
      v-model="inputVal"
      :optionList="displayedOptionList"
      :isMultiple="isMulti"
      :closeOnSelect="closeOnSelect"
      :placeholder="placeholder"
      :optionLabel="displayOptionLabel"
      :optionModel="displayOptionModel"
      :hasClearButton="hasClearButton"
      :buttonGroups="buttonGroups"
      :additionalSelectedInfoFunc="additionalSelectedInfoFunc"
      @clickBtn="$emit('clickBtn', $event)"
      @select="$emit('select', $event)"
      @userInput="$emit('userInput', $event)"
    />
    <div v-if="hasOther && isOtherSelected">
      <input
        type="text"
        class="form-control"
        :placeholder="`${otherOption} value`"
        v-model="otherValue"
        @input="handleOtherTextboxInput($event)"
      />
    </div>
    <p
      class="required-message"
      v-if="!isValueInputted && submitClicked && isRequired"
    >
      {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
    </p>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import MultiSelect from "../complex-input-elements/MultiSelect.vue";
import { RADIO_OTHER_OPTIONS_PREFIX } from "../../../constants/prefix";
/* This component includes a label, and a multiselect with its label
Any error of the checkbox group (for example: required field) is showed in this component */
export default {
  name: "MultiSelectWithLabel",
  props: {
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Input value, which is used for v-model
    value: [String, Array, Number],
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12",
    },
    // List of options for checkbox group (the label of each checkbox)
    optionList: {
      type: [Array, String, Object],
      default: () => [],
    },
    isMulti: {
      type: Boolean,
      default: false,
    },
    // Single select, but value is saved in an array
    isArrayModel: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    // Index of default selected option
    defaultValue: [Array, Number],
    optionLabel: String,
    optionModel: String,
    // Map option list to display in multiple languages
    mapOptionListByLang: {
      type: Object,
      default: () => {},
    },
    // key to get optionList (in case option list is an array)
    optionKey: {
      type: [String, Array],
    },
    hasClearButton: {
      type: Boolean,
      default: false,
    },
    formObject: Object, // data of all form
    optionListTransformFunc: Function, // Transform function of option list
    buttonGroups: Array, // List of buttons attached by the end of multiselect
    additionalSelectedInfoFunc: Function, // Function to display additional information of the selected item
    builderField: Object,
    infoLinkId: {
      type: String,
      default: null,
    },
    hasOther: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MultiSelect,
  },
  data() {
    let value = this.value;
    if (!this.isMulti && this.isArrayModel) {
      // Single select but result is saved in first element of array
      if (Array.isArray(this.value)) {
        if (this.value.length === 0) {
          value = null;
        } else {
          value = this.value[0];
        }
      }
    }
    return {
      inputVal: value,
      otherValue: "",
    };
  },
  created() {
    if (this.defaultValue != null && this.value == null) {
      if (this.isMulti) {
        if (Array.isArray(this.defaultValue)) {
          this.inputVal = this.defaultValue.map(
            (val) => this.normalizedOptionList[val]
          );
        } else {
          this.inputVal = this.normalizedOptionList[this.defaultValue];
        }
      } else {
        if (Array.isArray(this.defaultValue) && this.defaultValue.length > 0) {
          this.inputVal = this.normalizedOptionList[this.defaultValue[0]];
        } else {
          this.inputVal = this.normalizedOptionList[this.defaultValue];
        }
      }
    }
    if (
      !this.isMulti &&
      this.hasOther &&
      this.value &&
      this.value.indexOf(RADIO_OTHER_OPTIONS_PREFIX) === 0
    ) {
      // Other option is selected
      this.inputVal = this.otherOption;
      this.otherValue = this.removeOtherRadioPrefix(this.value);
    }
  },
  //   created() {
  //     if (this.isMulti) {
  //       this.$emit("input", [this.normalizedOptionList[0]]);
  //     } else {
  //       this.$emit("input", this.normalizedOptionList[0]);
  //     }
  //   },
  computed: {
    ...mapGetters(["getImportFieldChanged"]),
    isValueInputted() {
      if (!this.inputVal) {
        return false;
      }
      if (this.isMulti) {
        if (Array.isArray(this.inputVal)) {
          if (!this.inputVal.length) {
            return false;
          }
        }
      }
      return true;
    },
    hasAddOptionBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some((button) => button.id === "add-option");
    },
    hasAgencySettingBtn() {
      if (!this.buttonGroups) {
        return false;
      }
      return this.buttonGroups.some((button) => button.id === "agency-setting");
    },
    agencySettingBtn() {
      if (!this.hasAgencySettingBtn) {
        return {};
      }
      return this.buttonGroups.find((button) => button.id === "agency-setting");
    },
    normalizedOptionList() {
      if (Array.isArray(this.optionList)) {
        return this.optionList;
      }
      if (this.optionList == null) {
        return [];
      }
      if (typeof this.optionList === "object") {
        if (this.optionKey && this.optionList[this.optionKey]) {
          return this.optionList[this.optionKey];
        } else {
          return [];
        }
      }
      return this.optionList
        .split("\n")
        .map((option) => option.trim())
        .filter((option) => option.length > 0);
    },
    customizeInputOption() {
      return (
        this.mapOptionListByLang &&
        Object.keys(this.mapOptionListByLang).length &&
        !this.optionLabel &&
        !this.optionModel
      );
    },
    displayedOptionList() {
      if (this.optionListTransformFunc) {
        return this.optionListTransformFunc(
          this.formObject,
          this.normalizedOptionList
        );
      }
      if (this.customizeInputOption) {
        return Object.keys(this.mapOptionListByLang).map((key) => {
          return {
            original: key,
            display: this.mapOptionListByLang[key],
          };
        });
      } else {
        return this.normalizedOptionList;
      }
    },
    displayOptionLabel() {
      if (this.customizeInputOption) {
        return "display";
      }
      return this.optionLabel;
    },
    displayOptionModel() {
      if (this.customizeInputOption) {
        return "original";
      }
      return this.optionModel;
    },
    isOtherSelected() {
      if (!this.inputVal) {
        return false;
      }
      if (!this.optionListExcludeOther.includes(this.inputVal)) {
        return true;
      }
      return false;
    },
    optionListExcludeOther() {
      return this.normalizedOptionList.slice(0, -1);
    },
    otherOption() {
      return this.normalizedOptionList[this.normalizedOptionList.length - 1];
    },
  },
  watch: {
    inputVal: {
      handler(val, oldVal) {
        if (
          val === null ||
          val === "types" ||
          val === "tags" ||
          val === "locations"
        ) {
          const valIndex = this.getImportFieldChanged.indexOf(val);
          const oldValIndex = this.getImportFieldChanged.indexOf(oldVal);
          if (val && valIndex == -1) {
            this.addImportFieldChanged(val);
          }
          if (
            (oldValIndex !== -1 && val === null) ||
            (oldValIndex !== -1 && val)
          ) {
            this.deleteImportFieldChanged(oldValIndex);
          }
        }
        if (!this.isMulti && this.isArrayModel) {
          this.$emit("input", [val]);
        } else {
          if (this.hasOther && this.otherValue && this.isOtherSelected) {
            this.$emit("input", RADIO_OTHER_OPTIONS_PREFIX + this.otherValue);
          } else {
            this.$emit("input", val);
          }
        }
        if (val === null || val) {
          this.$emit("changed", val);
        }
      },
      immediate: true,
    },
    value: {
      handler() {
        if (!this.isMulti && !this.isArrayModel) {
          if (this.value !== this.inputVal) {
            if (
              this.hasOther &&
              this.value &&
              this.value.indexOf(RADIO_OTHER_OPTIONS_PREFIX) === 0
            ) {
              // Other option is selected
              this.inputVal = this.otherOption;
            } else {
              this.inputVal = this.value;
            }
          }
        }
        if (this.builderField && this.builderField.setOutside) {
          this.inputVal = this.value;
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(["addImportFieldChanged"]),
    ...mapActions(["deleteImportFieldChanged"]),
    getDisplayOption(option) {
      if (!this.mapOptionListByLang) {
        return option;
      }
      if (this.mapOptionListByLang[option]) {
        return this.mapOptionListByLang[option];
      }
      return option;
    },
    handleOtherTextboxInput(event) {
      this.$emit("input", RADIO_OTHER_OPTIONS_PREFIX + event.target.value);
    },
  },
};
</script>
<style scoped>
.multi-select-container {
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/common/form-elements/MultiSelectWithLabel.vue